import React from "react";
import PropTypes from "prop-types";
import classNames from "../../../utils/classNames";
import "./index.scss";

const refPropType = PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
]);

const PanelInputField = ({
    label,
    id,
    as = "input",
    className = "",
    inputClassName = "",
    fieldRef,
    fieldProps = {},
    controlChildren = null,
    children = null,
    ...inputProps
}) => {
    const controlClassName = classNames("panel-input-field__input", inputClassName);

    let control = null;

    if (as === "textarea") {
        control = (
            <textarea
                id={id}
                className={controlClassName}
                {...inputProps}
            >
                {controlChildren}
            </textarea>
        );
    } else if (as === "select") {
        control = (
            <select
                id={id}
                className={controlClassName}
                {...inputProps}
            >
                {controlChildren}
            </select>
        );
    } else {
        control = (
            <input
                id={id}
                className={controlClassName}
                {...inputProps}
            />
        );
    }

    return (
        <div
            className={classNames("panel-input-field", className)}
            ref={fieldRef}
            {...fieldProps}
        >
            <label htmlFor={id} className="panel-input-field__label">{label}</label>
            {control}
            {children}
        </div>
    );
};

PanelInputField.propTypes = {
    label: PropTypes.node.isRequired,
    id: PropTypes.string.isRequired,
    as: PropTypes.oneOf(["input", "textarea", "select"]),
    className: PropTypes.string,
    inputClassName: PropTypes.string,
    fieldRef: refPropType,
    fieldProps: PropTypes.object,
    controlChildren: PropTypes.node,
    children: PropTypes.node,
};

export default PanelInputField;
